<template>
    <section>
      <label>
          <small
              v-if="form.modeloEnvioId.required"
              class="text-danger"
          >*</small> Modelo:
      </label>
      <div class="input-group">
          <b-dropdown variant="addon" no-caret>
              <template slot="button-content">
                  <i class="fas fa-caret-down" />
              </template>
              <b-dropdown-item @click="onAddNewModeloEnvioModal">
                  <i class="fas fa-plus text-third" /> Criar
              </b-dropdown-item>
              <b-dropdown-item
                  @click="onEditTemplateModal"
                  :disabled="form.modeloEnvioId.value === null"
              >
                  <i class="fas fa-edit  text-third" /> Editar
              </b-dropdown-item>
          </b-dropdown>
          <b-form-select
              v-model="form.modeloEnvioId.value"
              :options="form.modeloEnvioId.options"
              @change="onSelect()"
          >
            <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
            </template>
          </b-form-select>
          <small class="small-help"><i class="fas fa-info-circle"></i> Ao criar, editar ou selecionar um modelo, aperte em salvar para registrar os cooperados na lista.</small>
      </div>

      <AddNewModeloEnvioModal ref="AddNewModeloEnvioModal" @reload="onGetAllTemplate" />
    </section>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import TemplateRepository from '@/shared/http/repositories/configurations/templates.js'

import AddNewModeloEnvioModal from '@/views/private/configurations/lista-inteligente/components/add/modal/AddNewModeloEnvioModal.vue'

const BaseSelectModeloEnvioData = {
  modeloEnvioId: null
}

const BaseSelectModeloEnvioForm = {
  modeloEnvioId: {
    value: null,
    options: [],
    required: true,
    state: null
  }
}

export default {
  name: 'BaseSelectModeloEnvio',
  mixins: [ActionsForm],
  components: {
    AddNewModeloEnvioModal
  },
  data () {
    return {
      data: BaseSelectModeloEnvioData,
      form: BaseSelectModeloEnvioForm
    }
  },
  methods: {
    onLoad () {
      this.onGetAllTemplate()
    },
    onAddNewModeloEnvioModal () {
      this.$refs.AddNewModeloEnvioModal.showModal()
    },
    onEditTemplateModal () {
      loading.push()
      TemplateRepository.GetById(this.form.modeloEnvioId.value)
        .then((response) => {
          const { data } = response
          this.$refs.AddNewModeloEnvioModal.onEdit(data)
          loading.close()
        })
        .catch(this.onException)
    },
    onGetAllTemplate () {
      loading.push()
      TemplateRepository.GetAllFinalidade('3')
        .then((response) => {
          this.form.modeloEnvioId.options = this.onResultDropdown(response, null, f => f.nome)
          loading.pop()
        })
        .catch(this.onException)
    },
    onSelect () {
      this.$emit('select', this.form.modeloEnvioId.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/component/BaseSelectModeloEnvio.vue